export default "__VITE_ASSET__xSxC5WwI__"